import { EMainProductCodeType } from '@aqx-core/common/api/config';
import { IOrder } from '@aqx-core/common/api/order';
import { EColumnPreferenceOrderType } from '@aqx-core/common/api/user-account-setting';
import { ORDERS_MAX_SIZE } from '@aqx-core/common/constants/order';
import dayjs, { getSecondsSinceEpoch } from '@aqx-core/common/dayjs';
import { i18n } from '@aqx-core/common/i18n';

import { companyViewController } from '../company/controller';
import { EDeleteOrderType, IOrderHistoryDateRange } from './types';

export const getDefaultHistoryDateRange = (): IOrderHistoryDateRange => {
  return {
    to: dayjs().endOf('day').toDate(),
    from: dayjs().subtract(1, 'months').startOf('day').toDate()
  };
};

export const getMappedOpenPositionsKeyByIntegration = (
  integrationType: EMainProductCodeType | undefined,
  order: IOrder
) => (integrationType === EMainProductCodeType.HORIZON ? order.symbol : order.orderId);

export const getOrderHistoryTabKeyByIntegration = (isHorizon: boolean, isMT4: boolean) =>
  isHorizon || isMT4 ? EColumnPreferenceOrderType.ORDER_HISTORY : EColumnPreferenceOrderType.POSITION_HISTORY;

export const mapDeletePendingOrderHeaderDescription = (deleteType: EDeleteOrderType) => {
  const MESSAGE_MAP = {
    [EDeleteOrderType.ALL]: () =>
      i18n.t('Note: A maximum of {{orderMaxSize}} pending orders will be deleted.', {
        orderMaxSize: ORDERS_MAX_SIZE
      }),
    [EDeleteOrderType.LIMIT]: () =>
      i18n.t('Note: A maximum of {{orderMaxSize}} limit orders will be deleted.', {
        orderMaxSize: ORDERS_MAX_SIZE
      }),
    [EDeleteOrderType.STOP]: () =>
      i18n.t('Note: A maximum of {{orderMaxSize}} stop orders will be deleted.', {
        orderMaxSize: ORDERS_MAX_SIZE
      }),
    [EDeleteOrderType.STOP_LIMIT]: () =>
      i18n.t('Note: A maximum of {{orderMaxSize}} stop limit orders will be deleted.', {
        orderMaxSize: ORDERS_MAX_SIZE
      })
  };
  return MESSAGE_MAP[deleteType]();
};

export const mapDeletePendingOrderConfirmMessage = (deleteType: EDeleteOrderType) => {
  const MESSAGE_MAP = {
    [EDeleteOrderType.ALL]: () => i18n.t('Would you like to delete all pending orders?'),
    [EDeleteOrderType.LIMIT]: () => i18n.t('Would you like to delete all limit orders?'),
    [EDeleteOrderType.STOP]: () => i18n.t('Would you like to delete all stop orders?'),
    [EDeleteOrderType.STOP_LIMIT]: () => i18n.t('Would you like to delete all stop limit orders?')
  };
  return MESSAGE_MAP[deleteType]();
};

export const mapDeletePendingOrderSuccessMessage = (deleteType: EDeleteOrderType) => {
  const MESSAGE_MAP = {
    [EDeleteOrderType.ALL]: () => i18n.t('All pending orders have been deleted.'),
    [EDeleteOrderType.LIMIT]: () => i18n.t('All limit orders have been deleted.'),
    [EDeleteOrderType.STOP]: () => i18n.t('All stop orders have been deleted.'),
    [EDeleteOrderType.STOP_LIMIT]: () => i18n.t('All stop limit orders have been deleted.')
  };
  return MESSAGE_MAP[deleteType]();
};

export const convertDateRangeWithUtcOffset = (dateRange: IOrderHistoryDateRange) => {
  const convertedFrom = companyViewController
    .convertToDayjsWithOffset({
      input: dateRange.from,
      keepTime: true,
      baseFromOffset: true
    })
    .startOf('day');

  const convertedTo = companyViewController
    .convertToDayjsWithOffset({
      input: dateRange.to,
      keepTime: true,
      baseFromOffset: true
    })
    .endOf('day');

  const epochFrom = getSecondsSinceEpoch(convertedFrom);
  const epochTo = getSecondsSinceEpoch(convertedTo);

  return {
    epochFrom,
    epochTo
  };
};
